import LobbyService from '@base/features/lobby/model/lobbyService';
import { useSubject } from '@base/utils/helpers';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { container } from 'tsyringe';
import { MAIN_ROUTES } from '../constants/mainRoutes';

export default function useTableSwitcher() {
  const history = useHistory();
  const lobbyService: LobbyService = container.resolve('lobbyService');
  const meJoinedTid = useSubject(lobbyService.onMeJoinedTable);
  const myTableJoined = useSubject(lobbyService.onMyTableJoined);

  useEffect(() => {
    if (meJoinedTid === undefined) return;
    // Я покинул стол
    if (meJoinedTid === -1) {
      history.push(MAIN_ROUTES.lobby);
    }
    // Я присоединился к столу или к моему столу присоединились
    else if (meJoinedTid > -1 || myTableJoined) {
      history.push(MAIN_ROUTES.game);
    }
  }, [meJoinedTid, history, myTableJoined]);
}
